exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remember-and-forgot .forgot[data-v-206fc8cc]{margin-top:10px}@media (min-width:470px){.remember-and-forgot[data-v-206fc8cc]{display:flex}.remember-and-forgot .forgot[data-v-206fc8cc]{flex:1;margin-top:0;text-align:right}}", ""]);

// exports
